import { createFileRoute } from '@tanstack/react-router'

import { TaxonomyTabsPage } from '@/pages/taxonomy/TaxonomyTabs.page'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/taxonomies',
)({
  component: TaxonomyTabsPage,
  loader: () => ({ breadcrumbTitle: 'Taxonomy' }),
})
